var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mine-help"},[_c('div',{staticClass:"mine-help-tip"},[_vm._v("常见问题")]),_vm._l((_vm.textList),function(item,index){return _c('help-item',{key:index,attrs:{"data-source":item},on:{"click":_vm.handleClick}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }